import classNames from '@app/ui/sports-components/utils/classNames';

type platformsType = {
    [key: string]: string;
};

export const platforms: platformsType = {
    '1': 'X',
    '2': 'Instagram',
    '3': 'Facebook',
    '23': 'Tiktok',
};

const getPlatformClass = platformId => {
    const platformName =
        platformId && platforms[platformId] ? platforms[platformId] : 'N/A';

    const lowerSocNam =
        platformName == 'Twitter' || platformName == 'X'
            ? 'x-twitter'
            : platformName.toLowerCase();
    return classNames(
        'photo-stream__card-block-social-icon',
        'fa-fw',
        '-m-r-2',
        'fab',
        'fab-fa6',
        {
            [`fa-${lowerSocNam}`]: !!lowerSocNam,
        },
    );
};

export default getPlatformClass;
